const UiInput1 = (props) => {
	const {field, value, userChangeHandler, countries, readOnly, dropdown, capitalize} = props


	return(
		<div className="input1 " style={{cursor: dropdown ? "pointer" : "none"}}>
			<div className="d-flex gap-2 justify-content-between align-self-center">
				<div style={{width: 20, height: 20, }} hidden={!field}>
					<img src={
						field == "email" ? 
						( "/src/email.png" )
						: ["confirm",  "password" ].includes(field) ? 
						("/src/pass.png"): 
						["first_name", "fname", "last_name", "lname"].includes(field) ?
						("/src/profile-circle.png")
						:

						 ["agency_name", "aname", "brand", "sellerVendor"].includes(field) ?
						("/src/building.png" )	
						:
						["zip", "marketplace", "country"].includes(field)?
						("/src/web.png" )
						:
						field == "mobile" ?
						( "/src/mobile.png" )
						:
						field == "location" ?
						("/src/location.png") 
						:
						null
						}  style={{width: "100%",}}/>
				</div>
				{["marketplace", "country", 'sellerVendor'].includes(field) ?
				<select className="flex-grow-1 poppins w-100 align-self-center" value={value}  onChange={e => userChangeHandler(e.target.value, field)}>
					
					{ props.sellerVendorList ? 
					<option className="poppins" value="">-select existing profile-</option>
					:
					<option className="poppins" value="">-select-</option>
					}
					{countries && countries.map( x => (
					<option className="poppins" key={x.cca2} value={x.cca2} >{x.name.common}</option>

					))

					}
					{props.marketplace &&  props.marketplace.map( (x, i) => (
					<option className="poppins" key={i} value={x.id} >{x.country}</option>

					))

					}
					{props.sellerVendorList &&  props.sellerVendorList.map( (x, i) => (
					<option className="poppins" key={i} value={x.profile_id}>{`${x.sellerName} (${x.profileId})`}</option>

					))

					}
				</select>
				:
				<input 
				readOnly={readOnly || false}
				value={value} onChange={e => readOnly ? null : userChangeHandler(e.target.value, field)}
				className={"flex-grow-1 poppins align-self-center"+(capitalize && " text-capitalize")} type={field == "email" ? "email" : ["confirm",  "password" ].includes(field) ? "password" : "text"}/>
				}
				{dropdown && <div className="dropdown-toggle"></div>}
			</div>
		</div>
	)


}

export default UiInput1